module.exports = __webpack_public_path__ + "img/2020-2.7583b810.jpg";